<template>
    <div class="bgFrame">
        <div class="bgSubFrame">
            <div class="bottomText">Copyright © 2022 NuMatch. Powered by CRV Consultants ( Hong Kong ) Ltd. All rights reserved. | Cookies Policy</div>
        </div>
    </div>
</template>

<script>

import {ref, onMounted } from "vue";

export default {
  name: 'App',
  components: {
  },
  setup() {
    onMounted(() => {
    });
    const serviceList = ref([
        {src: require('../../assets/facebook_hover.png'), link: ''},
        {src: require('../../assets/instagram_hover.png'), link: ''},
        {src: require('../../assets/youtube_hover.png'), link: ''},
        {src: require('../../assets/whatsapp_hover.png'), link: ''},
        {src: require('../../assets/wechat_hover.png'), link: ''},
        {src: require('../../assets/tiktok_hover.png'), link: ''}
    ])
    const shareControl = (index) =>{
        window.location.href = serviceList.value[index].link
    };
    return {
        shareControl,
        serviceList
    };
  },
}
</script>

<style lang="less" scoped>
.bgFrame{
    position: relative;
    width: calc(100%);
    height: 72px;
}
.bgSubFrame{
    position: absolute;
    top: 0;
    left: 0;
    background: #EAEAEA;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.bottomText{
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: #333333;
}

</style>
